export const NAME = 'dataProcessingElements';
